/**
 * @generated SignedSource<<cdb7e7595693d8408f3fbc09a0b7182f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TodoEditTagsPopover_todo$data = {
  readonly category: {
    readonly tags: ReadonlyArray<{
      readonly color: string;
      readonly id: string;
      readonly title: string;
    }>;
  } | null;
  readonly id: string;
  readonly tags: ReadonlyArray<{
    readonly id: string;
  }>;
  readonly " $fragmentType": "TodoEditTagsPopover_todo";
};
export type TodoEditTagsPopover_todo$key = {
  readonly " $data"?: TodoEditTagsPopover_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoEditTagsPopover_todo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoEditTagsPopover_todo",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategoryTag",
      "kind": "LinkedField",
      "name": "tags",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "TodoCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TodoCategoryTag",
          "kind": "LinkedField",
          "name": "tags",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "color",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "054a30418b06b1495063cf40e6d00b9b";

export default node;
